import React, { useState, useEffect, useMemo, useCallback } from "react";
import { DatePicker, Select, Space } from "antd";
import images from "../../themes/appImage";
import { useNavigate } from "react-router-dom";
import { Table, Modal, Popover , Button } from "antd";
import appconstant from "../../themes/appconstant";
import Flag from "react-country-flag";
import { useDispatch, useSelector } from "react-redux";
import { createOrgLoad, orglistLoad } from "../../redux/slices/org.slice";
import moment from "moment";
import { imageURL } from "../../redux/Api/apikit";
import { debounce } from "../../utils/global-func";
import * as Yup from "yup";
import { useFormik } from "formik";
import { emptySpaceInputHandler } from "../../utils";

const numberOfRowOptionList = [
  { value: "one", label: 10 },
  { value: "two", label: 20 },
  { value: "three", label: 25 },
];

const planOptionList = [
  { value: "premium", label: "Premium" },
  { value: "pro", label: "Pro" },
  { value: "ultimate", label: "Ultimate" },
];

const { Option } = Select;

const countryOptions = [
  { code: "US", label: "United States" },
  { code: "CA", label: "Canada" },
  { code: "GB", label: "United Kingdom" },
  // Add more countries as needed
];

let LIST_LIMIT = 10;
let OFFSET = 0;
let currentSortValue = -1;

const Organizations = () => {
  const [actionIndex, setActionIndex] = useState(null);

  const columns = [
    {
      title: "ID",
      dataIndex: "srno",
      key: "srno",
      sorter: false,
      width: "5%",
      render: (value, item, index) => OFFSET + index + 1,
    },
    {
      title: "Organization",
      dataIndex: "name",
      key: "name",
      sortDirections: ["ascend", "descend"],
      width: "20%",
      title: (v, r, i) => {
        return (
          <div onClick={() => sortHandler("name")} className="sort-icons">
            <span>Organization</span> <img src={images.arrowLeft} alt="" />
          </div>
        );
      },
      render: (value, item, index) => (
        <div className="organization-image-sec">
          <div className="flex items-center justify-center gap-4">
            {item?.image?.length > 0 && (
              <img
                className="w-6 h-6 rounded-[100%] object-contain"
                src={`${imageURL}${item.image}`}
              />
            )}
            <div>
              {item?.name?.length > 12
                ? `${item?.name.slice(0, 10)}....`
                : item?.name}
            </div>
          </div>
        </div>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      sorter: false,
      width: "20%",
    },
    {
      title: "No. of Users",
      dataIndex: "user",
      key: "user",
      sorter: false,
      sortDirections: ["ascend", "descend"],
      width: "10%",
      title: () => {
        return (
          <div onClick={() => sortHandler("user")} className="sort-icons">
            <span>No. of Users</span> <img src={images.arrowLeft} alt="" />
          </div>
        );
      },
    },
    {
      title: "Plan",
      dataIndex: "plan",
      key: "plan",
      sorter: false,
      width: "10%",

      render: (value, item, index) => (
        <div className="table-tb-plan">{item.plan}</div>
      ),
    },
    {
      title: "Expiry Date",
      dataIndex: "endDate",
      key: "endDate",
      sorter: false,
      sortDirections: ["ascend", "descend"],
      width: "10%",
      title: () => {
        return (
          <div onClick={() => sortHandler("endDate")} className="sort-icons">
            <span>Expiry Date</span> <img src={images.arrowLeft} alt="" />
          </div>
        );
      },
      render: (value, item, index) => (
        <div className="table-tb-plan">
          {moment(item.endDate).format("MMMM D, YYYY")}
        </div>
      ),
    },
    {
      title: "Actions",
      dataIndex: "Posted",
      key: "Posted",
      width: "10%",
      render: (value, item, index) => (
        <Popover
          content={
            <Button
              type="text"
              onClick={() => {
                navigate("/organizationssummary", {
                  state: {
                    id: item._id,
                    email: item.email,
                    name: item.name,
                    image: item.image,
                  },
                });
              }}
            >
              View
            </Button>
          }
          trigger="click"
        >
            <div className="relative action-dots-iocn">
          <span>
            <img src={images.horizontalDots} />
          </span>
          </div>
        </Popover>
      ),
    },
  ];

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");
  const [addOrgModal, setAddOrgModal] = useState(false);
  const { orgListData, orgListPaginationData, createdORGSuccess } = useSelector(
    (state) => state.orgReducer
  );

  useEffect(() => {
    const data = {
      offset: 0,
      limit: LIST_LIMIT,
      search: search,
      sort: "createdAt",
      order: -1,
    };
    dispatch(orglistLoad(data));
  }, []);

  useEffect(() => {
    if (createdORGSuccess) {
      const data = {
        offset: OFFSET,
        limit: LIST_LIMIT,
        search: search,
        sort: "createdAt",
        order: -1,
      };
      dispatch(orglistLoad(data));
      setAddOrgModal(false);
      resetFormik();
    }
  }, [createdORGSuccess]);

  // F O R M I K  F O R  -- A D D  N E W  O R G A N I Z A T I O N  M O D AL

  const validationSchema = Yup.object({
    plan: Yup.string().required("Please enter plan"),
    countryCode: Yup.string().required("Please enter country code"),
    phone: Yup.string().required("Please enter phone"),
    email: Yup.string()
      .email("Invalid email address")
      .required("Email is required")
      .max(50, "Email must be at most 50 characters"),
    name: Yup.string()
      .required("Please enter name")
      .max(30, "Name must be at most 30 characters"),
    image: Yup.string().required("Please enter image"),
    endDate: Yup.string().required("Please enter end date"),
    startDate: Yup.string().required("Please enter start date"),
  });

  const formik = useFormik({
    initialValues: {
      plan: "",
      countryCode: "",
      phone: "",
      email: "",
      name: "",
      image: "",
      endDate: "",
      startDate: "",
    },
    validationSchema,
    onSubmit: (values) => {
      const form = new FormData();
      form.append("plan", values.plan);
      form.append("countryCode", values.countryCode);
      form.append("phone", values.phone);
      form.append("email", values.email);
      form.append("name", values.name);
      form.append("image", values.image);
      form.append("endDate", values.endDate);
      form.append("startDate", values.startDate);
      dispatch(createOrgLoad(form));
    },
  });

  const resetFormik = () => {
    const newValues = {
      plan: "",
      countryCode: "",
      phone: "",
      email: "",
      name: "",
      image: "",
      endDate: "",
      startDate: "",
    };
    const newTouched = {
      plan: false,
      countryCode: false,
      phone: false,
      email: false,
      name: false,
      image: false,
      endDate: false,
      startDate: false,
    };
    formik.setValues(newValues);
    formik.setTouched(newTouched);
  };

  // P A G I N A T I O N

  // --S T A T E--
  const START = useMemo(() => OFFSET + 1, [orgListData]);
  const TOTAL_LIST_ITEMS = useMemo(
    () => orgListPaginationData?.totalCount,
    [orgListData]
  );
  const END = useMemo(
    () => Math.min(OFFSET + LIST_LIMIT, TOTAL_LIST_ITEMS),
    [orgListData]
  );
  const canCallNextData = OFFSET + LIST_LIMIT < TOTAL_LIST_ITEMS;
  // --A C T I O N S--
  const paginationHandler = useCallback(
    (type) => {
      if (type === "pre") {
        OFFSET = OFFSET - LIST_LIMIT;
        const data = {
          offset: OFFSET,
          limit: LIST_LIMIT,
          search: search,
          sort: "createdAt",
          order: -1,
        };
        dispatch(orglistLoad(data));
      } else {
        OFFSET = OFFSET + LIST_LIMIT;
        const data = {
          offset: OFFSET,
          limit: LIST_LIMIT,
          search: search,
          sort: "createdAt",
          order: -1,
        };
        dispatch(orglistLoad(data));
      }
    },
    [orgListData]
  );

  const numberOfRowHandler = useCallback(
    (ddateStringate, dataObj) => {
      LIST_LIMIT = dataObj.label;
      OFFSET = 0;
      const data = {
        offset: OFFSET,
        limit: LIST_LIMIT,
        search: search,
        sort: "createdAt",
        order: -1,
      };
      dispatch(orglistLoad(data));
    },
    [orgListData]
  );

  const searchHandler = useCallback(
    (e) => {
      if (emptySpaceInputHandler(e) || e.target.value.length == "") {
        LIST_LIMIT = 10;
        OFFSET = 0;
        setSearch(emptySpaceInputHandler(e));
        const data = {
          offset: 0,
          limit: 10,
          search: emptySpaceInputHandler(e).trim(),
          sort: "createdAt",
          order: -1,
        };
        debounce(() => dispatch(orglistLoad(data)));
      }
    },
    [orgListData]
  );

  const sortHandler = useCallback(
    (sort) => {
      sort = sort;
      currentSortValue = currentSortValue == -1 ? 1 : -1;
      const data = {
        offset: OFFSET,
        limit: LIST_LIMIT,
        search: search,
        sort: sort,
        order: currentSortValue,
      };
      dispatch(orglistLoad(data));
    },
    [orgListData]
  );

  const inputHandler = (event) => {
    let { name } = event.target;
    formik.setFieldValue(name, emptySpaceInputHandler(event));
  };

  return (
    <div>
      <div className="site-layout-background" style={{ minHeight: 360 }}>
        <div className="top-header-organi-zations">
          <div className="organi-zations-heading-text">
            <h1>Organizations</h1>
            {/* <p>
              Sed consectetur imperdiet facilisiulla malesua daeddiet
              facilisiulla
            </p> */}
          </div>
          <div className="add-new-button">
            <button onClick={() => setAddOrgModal(true)}>Add New</button>
          </div>
        </div>

        <div className="content-e">
          <div class="bg-gradient-primary  system-line">
            <input
              type="text"
              value={search}
              onChange={searchHandler}
              className="iocn-search  search-bar "
              placeholder="Search Organization"
            />
            {/* Version 2 */}
            {/* <div className="top-checkbox">
                }, [orgListData])

    const inputHandler = (event) => {
        let { name } = event.target;
        formik.setFieldValue(name, emptySpaceInputHandler(event));
    };

    return (
        <div>
            <div className="site-layout-background" style={{ minHeight: 360 }}>
                <div className="top-header-organi-zations">
                    <div className="organi-zations-heading-text">
                        <h1>Organizations</h1>
                        <p>Sed consectetur imperdiet facilisiulla malesua daeddiet facilisiulla</p>
                    </div>
                    <div className="add-new-button">
                        <button onClick={() => setAddOrgModal(true)}>Add New</button>
                    </div>
                </div>

                <div className="content-e">
                    <div class="bg-gradient-primary  system-line">
                        <input type="text" value={search} onChange={searchHandler} className="iocn-search  search-bar " placeholder="Search organization" />
                        {/* Version 2 */}
                        {/* <div className="top-checkbox">
                            <Select
                                defaultValue="Select Plan"
                                onChange={monthHandler}
                                options={monthOptionsList}
                            />
                        </div> */}
          </div>

          <Table
            className="table-wrapper"
            dataSource={orgListData}
            columns={columns}
            showSorterTooltip={false}
            pagination={{
              current: 0,
              pageSize: 0,
              total: TOTAL_LIST_ITEMS,
            }}
          />

          {TOTAL_LIST_ITEMS > 10 && (
            <div className="footer-section">
              <div className="foot-main-div">
                <div className="rows">
                  <div className="row-per-page">
                    <p>Rows per page</p>
                  </div>
                  <div className="top-checkbox fot-select">
                    <Select
                      defaultValue={LIST_LIMIT}
                      onChange={numberOfRowHandler}
                      options={numberOfRowOptionList}
                    />
                  </div>
                </div>

                <div className="page-count">
                  <p>{`${START}-${END} of ${TOTAL_LIST_ITEMS}`}</p>
                </div>

                <div className="back-and-next">
                  {/* <span><img src={images.back} alt="back" /></span> */}
                  <span
                    onClick={() => OFFSET !== 0 && paginationHandler("pre")}
                  >
                    <img
                      src={OFFSET == 0 ? images.per : images.paginationDimLeft}
                      style={{ tintColor: "red" }}
                      alt="back"
                    />
                  </span>
                  <span
                    onClick={() => canCallNextData && paginationHandler("next")}
                  >
                    <img
                      src={
                        canCallNextData == false
                          ? images.paginationDimRight
                          : images.new
                      }
                      alt="back"
                    />
                  </span>
                  {/* <span><img src={images.next} alt="back" /></span> */}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Add New Organization */}
      <Modal
        title=""
        className="modal-update new-organization "
        centered
        open={addOrgModal}
        closable={true}
        onCancel={() => {
          resetFormik();
          setAddOrgModal(false);
        }}
        footer={false}
        width={800}
      >
        <div className="add-user-popup">
          <div className="modal-add-user new-organi-zation-title">
            <h1>Add New Organization</h1>
          </div>
          <form onSubmit={formik.handleSubmit}>
            <div className="create-org-detail">
              <div className="orgn-plans">
                <label className="cursor-pointer" htmlFor="uploadCoverPic">
                  {formik.values.image ? (
                    <div className="relative">
                      <div
                        onClick={() => formik.setFieldValue("image", "")}
                        className="bg-white cursor-pointer p-2 w-5 h-5 absolute right-2 top-2 border border-black rounded-full flex justify-center items-center"
                      >
                        x
                      </div>
                      <img
                        className="w-36 h-28 rounded-full"
                        style={{ borderRadius: "100%" }}
                        src={URL.createObjectURL(formik.values.image)}
                        alt="uploadLogo"
                      />
                    </div>
                  ) : (
                    <div className="logo-upload">
                      <img src={images.uploadLogo} alt="uploadLogo" />
                      <p>Upload Logo</p>
                    </div>
                  )}
                  {formik.touched.image && formik.errors.image ? (
                    <div className="text-red-500 text-xs mt-1 font-normal">
                      {formik.errors.image}
                    </div>
                  ) : null}
                  <input
                    type="file"
                    id="uploadCoverPic"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      formik.setFieldValue("image", e.target.files[0])
                    }
                  />
                </label>

                <div className="modal-right-side">
                  <div className="form-group">
                    <label>{appconstant.organizationName}</label>
                    <input
                      className="form-control"
                      type="text"
                      placeholder="Enter organization name"
                      name="name"
                      value={formik.values.name}
                      onChange={inputHandler}
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <div className="text-red-500 text-xs mt-1 font-normal">
                        {formik.errors.name}
                      </div>
                    ) : null}
                  </div>

                  <div className="date-and-time mt-6">
                    <div className="form-group">
                      <label>{appconstant.email}</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter your email "
                        name="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.email && formik.errors.email ? (
                        <div className="text-red-500 text-xs mt-1 font-normal">
                          {formik.errors.email}
                        </div>
                      ) : null}
                    </div>

                    <div className="form-group flag-box">
                      <label>{appconstant.phone}</label>
                      <input
                        className="form-control country-flag-box"
                        type="number"
                        placeholder="Enter phone number "
                        name="phone"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                      {formik.touched.phone && formik.errors.phone ? (
                        <div className="text-red-500 text-xs mt-1 font-normal">
                          {formik.errors.phone}
                        </div>
                      ) : formik.touched.countryCode &&
                        formik.errors.countryCode ? (
                        <div className="text-red-500 text-xs mt-1 font-normal">
                          {formik.errors.countryCode}
                        </div>
                      ) : null}
                      <div className="country-flag">
                        <Select
                          val
                          style={{ width: 200 }}
                          dropdownRender={(menu) => <div>{menu}</div>}
                          onChange={(e) => {
                            formik.setFieldValue("countryCode", e);
                          }}
                          value={formik.values.countryCode}
                        >
                          {countryOptions.map((country) => (
                            <Option key={country.code} value={country.code}>
                              <Flag
                                countryCode={country.code}
                                svg
                                style={{ marginRight: 8 }}
                              />
                            </Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                  </div>

                  <div className="date-and-time mt-3.5">
                    <div className="select-date form-group">
                      <div className="textarea-label">
                        <label>{appconstant.startDate}</label>
                      </div>
                      <Space direction="vertical">
                        <DatePicker
                          onChange={(e) => formik.setFieldValue("startDate", e)}
                          placeholder="Date"
                          value={formik.values.startDate}
                        />
                        {formik.touched.startDate && formik.errors.startDate ? (
                          <div className="text-red-500 text-xs font-normal">
                            {formik.errors.startDate}
                          </div>
                        ) : null}
                      </Space>
                    </div>

                    <div className="select-date form-group">
                      <div className="textarea-label">
                        <label>{appconstant.expiryDate}</label>
                      </div>
                      <Space direction="vertical">
                        <DatePicker
                          onChange={(e) => formik.setFieldValue("endDate", e)}
                          placeholder="Date"
                          value={formik.values.endDate}
                        />
                        {formik.touched.endDate && formik.errors.endDate ? (
                          <div className="text-red-500 text-xs font-normal">
                            {formik.errors.endDate}
                          </div>
                        ) : null}
                      </Space>
                    </div>
                  </div>

                  <div className="plan-check-box mt-3.5">
                    <div className="textarea-label">
                      <label>{appconstant.plan}</label>
                    </div>
                    <Select
                      defaultValue="Select Plan"
                      onChange={(e) => formik.setFieldValue("plan", e)}
                      options={planOptionList}
                    />
                    {formik.touched.plan && formik.errors.plan ? (
                      <div className="text-red-500 text-xs font-normal">
                        {formik.errors.plan}
                      </div>
                    ) : null}
                  </div>

                  {/* <div className="app-features">
                                    <h1>App Features</h1>
                                    <div className="enable-btn">
                                        <div className="switch-btn">
                                            <Switch defaultChecked />
                                            <p>Log Mood</p>
                                        </div>

                                        <div className="switch-btn">
                                            <Switch defaultChecked />
                                            <p>Log Thoughts</p>
                                        </div>


                                        <div className="switch-btn">
                                            <Switch defaultChecked />
                                            <p>Affirmations</p>
                                        </div>

                                        <div className="switch-btn">
                                            <Switch defaultChecked />
                                            <p>Journal</p>
                                        </div>

                                        <div className="switch-btn">
                                            <Switch defaultChecked />
                                            <p>Meditation</p>
                                        </div>
                                        <div className="switch-btn">
                                            <Switch defaultChecked />
                                            <p>Therapy</p>
                                        </div>
                                        <div className="switch-btn">
                                            <Switch defaultChecked />
                                            <p>Playlists</p>
                                        </div>
                                    </div>
                                </div> */}
                </div>
              </div>
            </div>

            <div className="click-to-upload top-border-line">
              <div className="create-inner-circle-btn button-spacing">
                <button type="submit">Create Organization</button>
              </div>
            </div>
          </form>
        </div>
      </Modal>
    </div>
  );
};
export default Organizations;
